<template>
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="checkForm"
        label-width="100px"
        label-suffix=":"
        style="padding: 20px 0 0 0;border-top:1px solid #e7e7e7;"
    >
        <div
            v-if="isADValidator"
            class="text_next"
            style="color: red;"
        >如果您的电脑已加域，修改密码会同时修改电脑开机密码！</div>
        <el-form-item
            label="旧密码"
            prop="oldPass"
        >
            <el-input
                type="password"
                v-model="ruleForm.oldPass"
                style="width:200px;"
            ></el-input>
        </el-form-item>
        <el-form-item
            label="新密码"
            prop="newPass"
        >
            <el-input
                type="password"
                v-model="ruleForm.newPass"
                style="width:200px;"
            ></el-input>
        </el-form-item>
        <el-form-item
            label="确认密码"
            prop="checkPass"
        >
            <el-input
                type="password"
                v-model="ruleForm.checkPass"
                style="width:200px;"
            ></el-input>
        </el-form-item>
    </el-form>
</template>
<script>
import UserService from '@/services/user.service.js';
import LoginService from '@/services/login.service.js';
import SystemService from '@/services/system-service.js';
import { IsNull } from '../../utils/utils';
export default {
    created() {
        SystemService.getEntOrganizationInfo().then(res => {
            if (res && res.Success && res.Result) {
                this.isADValidator = res.Result.ADValidator === 'false' ? false : true;
            }
        });
        this.getSettingCenterInfo();
    },
    data() {
        var oldPass = (rule, value, callback) => {
            if (IsNull(value)) {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        var newPass = (rule, value, callback) => {
            if (IsNull(value)) {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        var checkPass = (rule, value, callback) => {
            if (IsNull(value)) {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.newPass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        var validatePasswordMode = (rule, value, callback) => {
            if (this.checkPass(value)) {
                var errorMessage = this.settingCenter.PasswordRuleWarning || '密码不符合规范!';
                callback(new Error(errorMessage));
            } else {
                callback();
            }
        };
        return {
            isADValidator: false,
            ruleForm: {
                oldPass: '',
                newPass: '',
                checkPass: '',
            },
            rules: {
                oldPass: {
                    required: true,
                    validator: oldPass,
                    trigger: 'change',
                },
                newPass: [
                    {
                        required: true,
                        validator: newPass,
                        trigger: 'change',
                    },
                    { validator: validatePasswordMode, trigger: 'blur' },
                ],
                checkPass: {
                    required: true,
                    validator: checkPass,
                    trigger: 'change',
                },
            },
            settingCenter: null,
        };
    },
    methods: {
        confirmAction: function() {
            return this.$refs.checkForm.validate().then(() => {
                return UserService.changePassword(
                    LoginService.userInfo.ObjectID,
                    this.ruleForm.newPass,
                    this.ruleForm.oldPass
                ).then(res => {
                    if (!res.Success) {
                        this.$message(res.Message);
                        return;
                    } else {
                        this.$message('成功修改密码！');
                        this.$emit('modalClose');
                    }
                });
            });
        },
        getSettingCenterInfo() {
            SystemService.GetSettingCenterInfo().then(res => {
                if (res.Result) {
                    this.settingCenter = res.Result;
                }
            });
        },
        checkPass(value) {
            if (this.settingCenter && !IsNull(this.settingCenter.PasswordRule)) {
                var rule = new RegExp(this.settingCenter.PasswordRule);
                if (!rule.test(value)) {
                    return true;
                }
            }
            return false;
        },
    },
};
</script>
